<template>
  <button :disabled="disabled || loader" :class="[computedClasses]" class="rounded-lg border px-7 py-1 select-none transition-colors disabled:cursor-not-allowed disabled:opacity-60">
    <Flex center class="px-4">
      <slot>
        {{ !loader ? label : '' }}
      </slot>
    </Flex>
  </button>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  outlined: Boolean,
  selected: Boolean,
  disabled: Boolean,
})

const computedClasses = computed(() => [
  {
    'border-cockpit-green/60 bg-cockpit-canvas text-cockpit-green hover:border-cockpit-green hover:bg-cockpit-green/10': !props.selected,
  },
  {
    'border-cockpit-green bg-cockpit-green text-cockpit-canvas': props.selected,
  },
])
</script>
